<mat-card class="login-card">
  <form #form="ngForm" (submit)="handleContinuar($event)" class="card-content">
    <mat-form-field class="fullwidth user-data-field" [class.error-margin]="inputCpf.touched && inputCpf?.errors" appearance="outline">
      <mat-label>Informe seu CPF</mat-label>
      <input
        id="inputCpf"
        name="inputCpf"
        type="text"
        #inputCpf="ngModel"
        [(ngModel)]="clientePreLogin.cpf"
        [modelSemMascara]="true"
        mascara="000.000.000-00"
        matInput
        document-validator
        class="errorClass"
        inputmode="numeric"
        placeholder="000.000.000-00"
        required
        (focus)="setFocus('inputCpf')"
        (blur)="removeFocus('inputCpf')">
        <button
            *ngIf="(hasFocus('inputCpf') || hasFocus('cancel-inputCpf')) && inputCpf.control.value?.length > 0" 
            mat-icon-button 
            matSuffix
            class="cancel-icon"
            type="button"
            (mouseover)="setFocus('cancel-inputCpf')"
            (mouseleave)="removeFocus('cancel-inputCpf')"
            (click)="clearField(inputCpf.control,'cancel-inputCpf')">
            <mat-icon >cancel</mat-icon>
        </button>
        <mat-error *ngIf="inputCpf.touched && inputCpf.getError('required')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Informe o número de CPF
        </mat-error>
        <mat-error *ngIf="inputCpf.touched && inputCpf.getError('documentIsInvalid')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Informe um CPF válido
        </mat-error>
    </mat-form-field>

    <mat-form-field class="fullwidth user-data-field" [class.error-margin]="inputTelefone.touched && inputTelefone?.errors" appearance="outline">
      <mat-label>DDD + Celular</mat-label>
      <input 
        name="inputTelefone"
        #inputTelefone="ngModel"
        [(ngModel)]="clientePreLogin.telefone"
        autocomplete="off"
        matInput
        inputmode="numeric"
        required
        [pattern]="phonePatternRegex"
        mascara="(00) 00000-0000"
        placeholder="(00) 00000-0000"
        (focus)="setFocus('inputTelefone')"
        (blur)="removeFocus('inputTelefone')">
        <button
            *ngIf="(hasFocus('inputTelefone') || hasFocus('cancel-inputTelefone')) && inputTelefone.control.value?.length > 0" 
            mat-icon-button 
            matSuffix
            class="cancel-icon"
            type="button"
            (mouseover)="setFocus('cancel-inputTelefone')"
            (mouseleave)="removeFocus('cancel-inputTelefone')"
            (click)="clearField(inputTelefone.control,'cancel-inputTelefone')">
            <mat-icon >cancel</mat-icon>
        </button>
        <mat-error *ngIf="inputTelefone.touched && inputTelefone?.getError('required')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Informe o número de celular
        </mat-error>
        <mat-error *ngIf="inputTelefone.touched && inputTelefone?.getError('pattern')">
          <mat-icon class="material-symbols-outlined mat-icon-error">error</mat-icon>
          Informe um celular válido
        </mat-error>
    </mat-form-field>

    <div class="rc-container">
      <re-captcha #recaptchaElem (resolved)="resolverRecaptcha($event)" siteKey="6Le8RiEoAAAAAGt8CyaZeHvEdBx40ZuVfOGKPqxL"></re-captcha>
    </div>

    <div class="action">
      <button 
        type="submit"
        mat-flat-button
        color="primary">
        <mat-icon *ngIf="loading">
          <mat-spinner diameter="20">
          </mat-spinner>
        </mat-icon>
          Continuar
      </button>

      <button type="button" class="link-button" (click)="gotToSignIn()">
        Primeiro acesso
      </button>
    </div>
  </form>
</mat-card>